import script from "./BalChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalChip.vue?vue&type=script&setup=true&lang=ts"

import "./BalChip.vue?vue&type=style&index=0&id=e737f40c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e737f40c"]])

export default __exports__